export default {
      id: "andragogy-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#andragogy",
      toString: function () {
        return this.url;
      }
    }